/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractTunnelDto
 */
export interface GroupContractTunnelDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    tunnelCode: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    tunnelName: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractTunnelDto
     */
    branchName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupContractTunnelDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractTunnelDto
     */
    activatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractTunnelDto
     */
    deactivatedAt?: Date;
}

/**
 * Check if a given object implements the GroupContractTunnelDto interface.
 */
export function instanceOfGroupContractTunnelDto(value: object): value is GroupContractTunnelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('tunnelCode' in value) || value['tunnelCode'] === undefined) return false;
    if (!('tunnelName' in value) || value['tunnelName'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GroupContractTunnelDtoFromJSON(json: any): GroupContractTunnelDto {
    return GroupContractTunnelDtoFromJSONTyped(json, false);
}

export function GroupContractTunnelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractTunnelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tunnelId': json['tunnelId'],
        'tunnelCode': json['tunnelCode'],
        'tunnelName': json['tunnelName'],
        'productName': json['productName'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'isActive': json['isActive'],
        'activatedAt': json['activatedAt'] == null ? undefined : (new Date(json['activatedAt'])),
        'deactivatedAt': json['deactivatedAt'] == null ? undefined : (new Date(json['deactivatedAt'])),
    };
}

export function GroupContractTunnelDtoToJSON(json: any): GroupContractTunnelDto {
    return GroupContractTunnelDtoToJSONTyped(json, false);
}

export function GroupContractTunnelDtoToJSONTyped(value?: GroupContractTunnelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tunnelId': value['tunnelId'],
        'tunnelCode': value['tunnelCode'],
        'tunnelName': value['tunnelName'],
        'productName': value['productName'],
        'branchName': value['branchName'],
        'isActive': value['isActive'],
        'activatedAt': value['activatedAt'] == null ? undefined : ((value['activatedAt']).toISOString()),
        'deactivatedAt': value['deactivatedAt'] == null ? undefined : ((value['deactivatedAt']).toISOString()),
    };
}

